import { useTranslation } from 'react-i18next';

import type { LinkItem } from '../../lib/types';
import { ResultSection } from '../ResultSection';

export interface TracksListProps {
  items: LinkItem[];
}

export function TracksList({ items }: TracksListProps) {
  const { t } = useTranslation('wmgone');

  if (!items.length) {
    return null;
  }

  return (
    <ResultSection
      iconType="music"
      title={t('globalSearch.result.tracks.title')}
    >
      {t('notImplemented')}
    </ResultSection>
  );
}

TracksList.displayName = 'TracksList';
